import apiClient from "../../utils/apiClient";

const API_URL = "/master";

export async function getStates() {
  try {
    const response = await apiClient.get(`${API_URL}/states`);
    return response.data;
  } catch (error) {
    console.error('Error fetching states:', error);
    throw error;
  }
}

export async function getvehicle() {
  try {
    const response = await apiClient.get(`${API_URL}/vehicle`);
    return response.data;
  } catch (error) {
    console.error('Error fetching vehicle:', error);
    throw error;
  }
}